import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelsFetchFailedAction = {
	type: 'AI_MODELS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelsFetchFailedAction => ({
	type: 'AI_MODELS_FETCH_FAILED',
	payload,
});
